<template>
    <div class="container">
        <div class="row" style="height: auto;">

            <div class="col-9">
                <div class="content">{{ problem.problemcontent }}</div>
                <h4>输入格式:</h4>
                <div class="h4-1">{{ problem.input }}</div>

                <h4>输出格式:</h4>
                <div class="h4-1">{{ problem.output }}</div>

                <h4>数据范围</h4>
                <div class="h4-1">{{ problem.pbrange }}</div>

                <h4>输入样例:</h4>
                <pre class="pre-1">{{ problem.inexample }}</pre>

                <h4>输出样例:</h4>
                <pre class="pre-1">{{ problem.outexample }}</pre>
            </div>

            <div class="col-3" style="max-height: 200px;">
                <div class="TR" style="background-color: #eae7e7;">
                    <div style="margin-right: 160px;">难度:</div> 
                    <el-tag v-show="problem.difficulty === '简单'" type="success" style="font-size: 14px; margin-top: 4px; float: right;">{{ problem.difficulty }}</el-tag>
                    <el-tag v-show="problem.difficulty === '适中'" type="warning" style="font-size: 14px; margin-top: 4px; float: right;">{{ problem.difficulty }}</el-tag>
                    <el-tag v-show="problem.difficulty === '困难'" type="danger" style="font-size: 14px; margin-top: 4px; float: right;">{{ problem.difficulty }}</el-tag>
                </div>
                <div class="TR">
                    时/空要求: {{ problem.tm }}
                </div>
                <div class="TR" style="background-color: #eae7e7;">
                    来源: {{ problem.pbfrom }}
                </div>
                <div class="TR">
                    <span style="margin-right: 10px;">算法标签:</span> <span> {{ problem.altag }}</span>
                </div>
            </div>

        </div>
        <div class="row" style="margin-top: 100px;">
            <div style="border: 1px solid lightgrey;">
                <div style="padding-top: 20px; padding-left: 900px;">
                    <el-select v-model="value" placeholder="请选择语言">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>

                <div class="col" style="margin-top:2vh;">
                    <editor
                        min-height="650"
                        height="650" 
                        width="100%"
                        ref="editor" 
                        :content="content" 
                        v-model="content"
                        :options="{
                            enableBasicAutocompletion: true,
                            enableSnippets: true,
                            enableLiveAutocompletion: true,
                            tabSize:4,
                            fontSize:20,
                            showPrintMargin:false,   //去除编辑器里的竖线
                        }"
                        :lang="'java'"
                        @init="editorInit">
                    </editor>
                </div>

                <div style="padding-top: 20px; padding-left: 900px; padding-bottom: 20px;">
                    <el-button type="primary" round @click="ClickMeToTest">调试代码</el-button>
                    <el-button type="success" round @click="ClickMeToSubmit">提交代码</el-button>
                </div>
                <div v-show="CanShow" style="font-size: 18px; padding: 10px; background-color: #F5F5F5;">
                    <div> 
                        <span style="font-size: 18px">代码提交状态：</span>
                        <span v-loading="loading" :style="obj">{{ status }}</span>
                    </div>
                </div>
                <span style="font-size: 16px;" v-show="status !== 'Accept' && status !== ''" >输入</span>
                <el-input
                    v-show="status !== 'Accept' && status !== ''"
                    style="resize: none; margin-top: 10px; margin-bottom: 10px; font-size: 15px;" 
                    type="textarea" 
                    :rows="1"
                    placeholder="请输入内容"
                    v-model="input[0]"
                    clearable>
                </el-input>
                <span style="font-size: 16px;" v-show="status !== 'Accept' && status !== ''">输出</span>
                <pre style="margin-top: 10px; white-space: pre-wrap; word-wrap: break-word; padding: 10px; font-size: 15px; background-color: #F8F8F8;" v-show="status !== 'Accept' && status !== ''">{{ result }}</pre>
            </div>
        </div>
    </div>
</template>

<script>
    import editor from "vue2-ace-editor"
    import $ from 'jquery'

    export default {
        name:'Content',
        components: {
            editor,
        },
        data() {
            return{
                loading: true,
                CanShow: false,
                input:[],
                obj: {
                    color: "",
                },
                obj1: {
                    color: "#67C23A"
                },
                obj2: {
                    color: "#F56C6C"
                },

                content:"", // 代码内容
                status:'',//代码运行后的状态
                result:'',//返回代码运行后的结果
                time:"", // 运行时间
                memory:'', // 空间
                options: [{
                    value: 'C ++',
                    label: 'C ++'
                }, {
                    value: 'Java',
                    label: 'Java'
                }, {
                    value: 'Python3',
                    label: 'Python3'
                }],
                value: 'C ++',

                problem:{},
            }
        },
        created() {
            const params = this.$route.params
            const vue = this

            $.ajax({
                url:'https://app6132.acapp.acwing.com.cn/api/question/get/one/',
                type:'post',
                data: {
                    id: params.id,
                },
                success(resp) {
                    if (resp.error_message === "success") {
                        vue.problem = JSON.parse(resp.problem);
                    } else {
                        console.log("题目信息获取失败了, error_message == >", resp.error_message)
                    }
                },
                error(resp) {
                    console.log("题目信息获取彻底失败了, resp == >", resp)
                }
            })
        },
        methods: {
            editorInit() {
                require("brace/ext/language_tools");
                require("brace/mode/java");   
                require("brace/snippets/java");
                require("brace/theme/eclipse");
            },
            ClickMeToTest() {
                const vue = this
                const store = this.$store
                const route = this.$route

                vue.CanShow = true // 这样就看看到转圈圈的状态了
                vue.loading = true

                if (this.value === "C ++") {
                    $.ajax({
                        url: "https://app6132.acapp.acwing.com.cn/jdg/problems/rungcc/",
                        type: "POST",
                        data: ({
                            input: vue.input,
                            username: store.state.me.name, 
                            content_pbid: vue.problem.pbid,
                            code: vue.content.trim(),
                            photo: store.state.me.photo,
                            uid: store.state.me.id,
                        }),
                        success(resp) {
                            vue.status = resp.status
                            vue.result = resp.result[0].answer
                            vue.loading = false
                            console.log("resp == ", resp)
                            if (vue.status === "Accept" || vue.status === "Finished") {
                                vue.obj = vue.obj1
                            } else {
                                vue.obj = vue.obj2
                            }
                        }
                    })
                } else if (this.value === "Java"){
                    $.ajax({
                        url: "https://app6132.acapp.acwing.com.cn/jdg/problems/runjava/",
                        type: "POST",
                        data: ({
                            input: vue.input,
                            username: store.state.me.name, 
                            content_pbid: vue.problem.pbid,
                            code: vue.content.trim(),
                            photo: store.state.me.photo,
                            uid: store.state.me.id,
                        }),
                        success(resp) {
                            vue.status = resp.status
                            vue.result = resp.result[0].answer
                            vue.loading = false
                            console.log("resp == ", resp)
                            if (vue.status === "Accept" || vue.status === "Finished") {
                                vue.obj = vue.obj1
                            } else {
                                vue.obj = vue.obj2
                            }
                        }
                    })
                } else {
                    $.ajax({
                        url: "https://app6132.acapp.acwing.com.cn/jdg/problems/runpy/",
                        type: "POST",
                        data: ({
                            input: vue.input,
                            username: store.state.me.name, 
                            content_pbid: vue.problem.pbid,
                            code: vue.content.trim(),
                            photo: store.state.me.photo,
                            uid: store.state.me.id,
                        }),
                        success(resp) {
                            vue.status = resp.status
                            vue.result = resp.result[0].answer
                            vue.loading = false
                            console.log("resp == ", resp)
                            if (vue.status === "Accept" || vue.status === "Finished") {
                                vue.obj = vue.obj1
                            } else {
                                vue.obj = vue.obj2
                            }
                        }
                    })
                }
                
            },
            ClickMeToSubmit() {
                const vue = this
                const store = this.$store
                if (!store.state.me.is_login) {
                    this.$notify({
                    title: '通知：',
                    message: '请先登录',
                    position: 'top-left'
                    });
                    return ;
                }
                const route = this.$route
                
                var currentDate = new Date();
                var year = currentDate.getFullYear(); // 年份
                var month = currentDate.getMonth(); // 月份 (0-11, 0 表示一月)
                var day = currentDate.getDate(); // 日期 (1-31)
                var hours = (currentDate.getHours() + 8) % 24; // 小时 (0-23)
                var minutes = currentDate.getMinutes(); // 分钟 (0-59)
                var seconds = currentDate.getSeconds(); // 秒 (0-59)
                var currentTime = year + "-" + (month + 1) + "-" + day + " " + hours + ":" + minutes + ":" + seconds;


                var currentDate = new Date();
                var options = {
                timeZone: 'Asia/Shanghai',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
                };
                vue.CanShow = true // 这样就看看到转圈圈的状态了
                vue.loading = true
                var chineseTime = currentDate.toLocaleString('zh-CN', options).replace(/\//g, '-');

                if (this.value === "C ++") {
                    $.ajax({
                        url: "https://app6132.acapp.acwing.com.cn/jdg/problems/judgegcc/",
                        type: "POST",
                        data: ({
                            username: store.state.me.name, 
                            content_pbid: vue.problem.pbid,
                            code: vue.content.trim(),
                            update_time: chineseTime,
                            photo: store.state.me.photo,
                            uid: store.state.me.id,
                        }),
                        success(resp) {
                            vue.status = resp.status
                            vue.result = resp.result[0].answer
                            vue.loading = false
                            console.log("resp == ", resp)
                            if (vue.status === "Accept" || vue.status === "Finished") {
                                vue.obj = vue.obj1
                            } else {
                                vue.obj = vue.obj2
                            }
                        }
                    })
                }
                else if (this.value === "Java") {
                    $.ajax({
                        url: "https://app6132.acapp.acwing.com.cn/jdg/problems/judgejava/",
                        type: "POST",
                        data: ({
                            username: store.state.me.name, 
                            content_pbid: vue.problem.pbid,
                            code: vue.content.trim(),
                            update_time: chineseTime,
                            photo: store.state.me.photo,
                            uid: store.state.me.id,
                        }),
                        success(resp) {
                            console.log(resp.status)
                            console.log("resp == ", resp)
                            vue.status = resp.status
                            vue.loading = false

                            if (vue.status === "Accept" || vue.status === "Finished") {
                                vue.obj = vue.obj1
                            } else {
                                vue.obj = vue.obj2
                            }
                        }
                    })
                }
                else if (this.value === "Python3"){
                    $.ajax({
                        url: "https://app6132.acapp.acwing.com.cn/jdg/problems/judgepy/",
                        type: "POST",
                        data: ({
                            username: store.state.me.name, 
                            content_pbid: vue.problem.pbid,
                            code: vue.content.trim(),
                            update_time: chineseTime,
                            photo: store.state.me.photo,
                            uid: store.state.me.id,
                        }),
                        success(resp) {
                            console.log(resp.status)
                            vue.status = resp.status
                            vue.loading = false

                            if (vue.status === "Accept" || vue.status === "Finished") {
                                vue.obj = vue.obj1
                            } else {
                                vue.obj = vue.obj2
                            }
                        }
                    })
                }
            },
            ReadLungCode(type) {
                const vue = this
                const store = this.$store
                const route = this.$route
                if (type === "C ++") {
                    $.ajax({
                        url: "https://app6132.acapp.acwing.com.cn/jdg/problems/getgcc/",
                        type: "POST",
                        data: ({
                            username: store.state.me.id, 
                            content_pbid: route.params.id,
                        }),
                        success(resp) {
                            console.log("code = ", resp)
                            vue.content = resp.code
                        }
                    })
                } else if (type === "Java") {
                    $.ajax({
                        url: "https://app6132.acapp.acwing.com.cn/jdg/problems/getjava/",
                        type: "POST",
                        data: ({
                            username: store.state.me.id, 
                            content_pbid: route.params.id,
                        }),
                        success(resp) {
                            console.log("code = ", resp)
                            vue.content = resp.code
                            if (vue.content.trim() === "") {
                                vue.content = 'public class Main {\n    \n}'
                            }
                        },
                        error(resp) {
                            if (vue.content.trim() === "") {
                                vue.content = 'public class Main {\n    \n}'
                            }
                        }
                    })
                } else if (type === "Python3") {
                    $.ajax({
                        url: "https://app6132.acapp.acwing.com.cn/jdg/problems/getpy/",
                        type: "POST",
                        data: ({
                            username: store.state.me.id, 
                            content_pbid: route.params.id,
                        }),
                        success(resp) {
                            console.log("code = ", resp)
                            vue.content = resp.code
                        }
                    })
                }
            },
            ReadExample() {
                const vue = this
                const store = this.$store
                const route = this.$route
                $.ajax({
                    url: "https://app6132.acapp.acwing.com.cn/api/example/select/",
                    type: "post",
                    data: {
                        pbid: route.params.id,
                    },
                    // headers: {
                    //     Authorization: "Bearer " + store.state.me.token // 这样可以拿到其他模块的数据
                    // },
                    success(resp) {
                        const list = JSON.parse(resp.List)
                        console.log("list == >", list)
                        vue.input[0] = list.map( obj => obj.inexample)[0]
                        console.log("input == > ", vue.input)
                    },
                    error(resp) {
                        console.log("未成功接收样例， resp == > ", resp)
                    }
                })
            },
        },
        watch: {
            value: {
                deep:true,
                immediate: true,
                handler(newvalue) { // 切换了语言就重新获取代码捏
                    const store = this.$store
                    this.content = ""
                    if (newvalue === "C ++") {
                        if (this.$store.state.me.id !== "") this.ReadLungCode("C ++")
                        else {
                            const t = setInterval(() => {
                                if (this.$store.state.me.id !== "") {
                                    this.ReadLungCode("C ++")
                                    clearInterval(t); // 清除定时器
                                }
                            }, 100);
                        }
                    } else if (newvalue === "Python3") {
                        if (this.$store.state.me.id !== "") this.ReadLungCode("Python3")
                        else {
                            const t = setInterval(() => {
                                if (this.$store.state.me.id !== "") {
                                    this.ReadLungCode("Python3")
                                    clearInterval(t); // 清除定时器
                                }
                            }, 100);
                        }
                    } else if (newvalue === "Java") {
                        if (this.$store.state.me.id !== "") this.ReadLungCode("Java")
                        else {
                            const t = setInterval(() => {
                                if (this.$store.state.me.id !== "") {
                                    this.ReadLungCode("Java")
                                    clearInterval(t); // 清除定时器
                                }
                            }, 100);
                        }
                    }
                }
            },

        },
        mounted() {
            this.ReadExample()
        }
    }
</script>

<style scoped>
.contain {
    height: auto;
}
.content {
    width:850px;
    padding: 20px 0 20px 0;
    font-size:15px;
    overflow: hidden;
    min-height: 20px;
    height: auto;
    white-space: pre-wrap; /*css-3*/ 
    word-wrap: break-word; /*InternetExplorer5.5+*/ 
}
.TR {
    border: 1px solid rgb(228, 228, 228);
    padding: 5px;
    width: 100%;
    line-height: 40px;
    min-height: 45px;
    height: auto;
    display: flex;
    padding-top: 5px;
    /* align-content: center; */
}
h4 {
    font-size: 16px;
    font-weight:600; 
    width:100%; 
    padding-top:4px;
}
.h4-1 {
    overflow: hidden;
    font-size: 14px;
    min-width: 200px;
    max-width: 400px;
    min-height: 20px;
    height: auto;
    padding-top:2px;
    height: auto;
    white-space: pre-wrap; /*css-3*/ 
    word-wrap: break-word; /*InternetExplorer5.5+*/ 
    padding-bottom: 4px;
}
.pre-1 {
    background-color: #dee0e1;
    overflow: hidden;
    font-size: 15px;
    width: 820px;
    min-height: 20px;
    height: auto;
    padding-top:2px;
    height: auto;
    white-space: pre-wrap; /*css-3*/ 
    word-wrap: break-word; /*InternetExplorer5.5+*/ 
}
</style>